import React, { Component, Fragment } from 'react';
import Moment from 'moment';
import 'moment/locale/es';
import Select from 'react-select';
import { CSVLink } from 'react-csv';
import Breadcrumb from '../common/breadcrumb';
import AuthService from '../services/auth.service';
import ApiService from '../services/api.service';
import { SortableTh, sortRows, nextSort } from '../common/sortable-th';

Moment.locale('es');

const NUM_MONTHS_WINDOW = 12;

function fmtMoney(val) {
    if (val === null || val === undefined || val === '') return '—';
    const num = parseFloat(val);
    if (isNaN(num)) return '—';
    return 'S/ ' + num.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// las claves de mes vienen como "YYYY-M" (o "YYYY-MM"); se ordenan
// cronológicamente y se formatean lindo para el header de la columna
function monthKeyLabel(key) {
    const m = Moment(key, 'YYYY-M');
    return m.isValid() ? m.format('MMM YYYY') : key;
}

function csvFilename(monthKeys) {
    const from = monthKeys.length > 0 ? monthKeys[0] : Moment().format('YYYY-M');
    const to = monthKeys.length > 0 ? monthKeys[monthKeys.length - 1] : from;
    return `desempeno-skus_${from}_a_${to}.csv`;
}

export class VerReportSkuForMonth extends Component {
    constructor(props) {
        super(props);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.handleSort = this.handleSort.bind(this);

        this.handleChange = this.handleChange.bind(this);

        this.state = {
            results: [],
            temp: [],
            monthKeys: [],
            filter: '',
            loading: false,
            page: 1,
            sort: { key: 'Producto', dir: 'asc' },
            dataCateg: [],
            dataListCateg: [],
            selectedOption: null,
        };
    }

    componentWillMount() {
        this.getDataCateg();
    }

    // arranca con el menú lateral cerrado para dejar más espacio a la tabla
    // (mismo patrón que ver-report-order-list / ver-customer-profile), y lo
    // restaura al salir de la vista
    componentDidMount() {
        document.querySelector(".page-main-header") &&
            document.querySelector(".page-main-header").classList.add("open");
        document.querySelector(".page-sidebar") &&
            document.querySelector(".page-sidebar").classList.add("open");
    }

    componentWillUnmount() {
        document.querySelector(".page-main-header") &&
            document.querySelector(".page-main-header").classList.remove("open");
        document.querySelector(".page-sidebar") &&
            document.querySelector(".page-sidebar").classList.remove("open");
    }

    getDataCateg() {
        const user = AuthService.getCurrentUser();
        ApiService.getDataReportsMonthsAndYearsSku(user.token).then((res) => {
            if (res && res.status === 'success') {
                const items = res.data.map((row, i) => ({
                    value: i,
                    label: Moment(`${row.year2}-${row.month2}`, 'YYYY-M').format('MMMM YYYY'),
                }));
                this.setState({ dataCateg: items, dataListCateg: res.data });

                // auto-selecciona el mes actual si está en la lista, y trae
                // los datos de una -- si no está (ej. todavía no hay ventas
                // este mes), igual pide el mes actual sin marcar nada en el select
                const now = Moment();
                const currentIndex = res.data.findIndex(
                    (row) => String(row.year2) === now.format('YYYY') && String(row.month2) === now.format('M')
                );
                if (currentIndex >= 0) {
                    this.setState({ selectedOption: items[currentIndex] });
                }
                this.getData(now.format('M'), now.format('YYYY'));
            }
        });
    }

    handleChange(selectedOption) {
        const { dataListCateg } = this.state;
        const entry = dataListCateg[selectedOption.value];
        this.setState({ selectedOption });
        this.getData(entry.month2, entry.year2);
    }

    getData(month, year) {
        const user = AuthService.getCurrentUser();
        this.setState({ loading: true });

        ApiService.getProductsReport(user.token, month, year).then(
            (res) => {
                if (res && res.status === 'success') {
                    const combinedReports = res.data.combinedReports;
                    const monthKeys = [...new Set(res.data.headersTable)].sort((a, b) => {
                        const ma = Moment(a, 'YYYY-M');
                        const mb = Moment(b, 'YYYY-M');
                        return ma.valueOf() - mb.valueOf();
                    });

                    const rows = [];
                    for (const idProduct in combinedReports) {
                        if (!combinedReports.hasOwnProperty(idProduct)) continue;
                        const dataRows = combinedReports[idProduct];
                        const latestData = dataRows[dataRows.length - 1];

                        const row = {
                            Id: idProduct,
                            Producto: latestData.name,
                            Categoría: latestData.category,
                            Subcategoría: latestData.subcategory,
                        };
                        monthKeys.forEach((key) => {
                            row[key] = 0;
                        });
                        dataRows.forEach((data) => {
                            const dateKey = `${data.year_report}-${data.month_report}`;
                            if (row.hasOwnProperty(dateKey)) {
                                row[dateKey] = parseFloat(data.total) || 0;
                            }
                        });

                        rows.push(row);
                    }

                    // por defecto ordena por el mes más reciente (de mayor a
                    // menor) -- así se ve directo qué se vendió más este mes
                    const lastMonthKey = monthKeys[monthKeys.length - 1];
                    this.setState({
                        results: rows,
                        temp: rows,
                        monthKeys,
                        loading: false,
                        page: 1,
                        sort: lastMonthKey ? { key: lastMonthKey, dir: 'desc' } : this.state.sort,
                    });
                } else {
                    this.setState({ results: [], temp: [], monthKeys: [], loading: false });
                }
            },
            () => {
                this.setState({ loading: false });
            }
        );
    }

    onChangeFilter(e) {
        const val = e.target.value.toLowerCase();
        this.setState({ filter: e.target.value });

        if (this.state.temp.length !== 0) {
            const columns = Object.keys(this.state.temp[0]);
            const rows = this.state.temp.filter((d) => {
                for (let i = 0; i < columns.length; i++) {
                    const col = columns[i];
                    if (d[col] && d[col].toString().toLowerCase().indexOf(val) > -1) return true;
                }
                return false;
            });
            this.setState({ results: rows, page: 1 });
        }

        e.preventDefault();
    }

    handleSort(key) {
        this.setState((prev) => ({
            sort: nextSort(prev.sort, key),
            page: 1,
        }));
    }

    renderPagination(total, page, pageSize, onPageChange) {
        const totalPages = Math.ceil(total / pageSize);
        if (totalPages <= 1) return null;
        const from = (page - 1) * pageSize + 1;
        const to = Math.min(page * pageSize, total);
        return (
            <div style={{
                display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between',
                padding: '10px 16px', borderTop: '1px solid #f0f0f0', gap: 8,
                background: '#fafafa', fontSize: 13, color: '#666',
            }}>
                <span style={{ fontSize: 12, color: '#aaa' }}>{from}–{to} de {total}</span>
                <div style={{ display: 'flex', gap: 6 }}>
                    <button
                        disabled={page === 1}
                        onClick={() => onPageChange(page - 1)}
                        style={{
                            border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
                            background: page === 1 ? '#f4f4f4' : '#fff',
                            color: page === 1 ? '#ccc' : '#333',
                            cursor: page === 1 ? 'default' : 'pointer', fontSize: 13,
                        }}
                    >
                        <i className="fa fa-chevron-left" />
                    </button>
                    <span style={{ padding: '4px 10px', fontSize: 13, color: '#555' }}>{page} / {totalPages}</span>
                    <button
                        disabled={page === totalPages}
                        onClick={() => onPageChange(page + 1)}
                        style={{
                            border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
                            background: page === totalPages ? '#f4f4f4' : '#fff',
                            color: page === totalPages ? '#ccc' : '#333',
                            cursor: page === totalPages ? 'default' : 'pointer', fontSize: 13,
                        }}
                    >
                        <i className="fa fa-chevron-right" />
                    </button>
                </div>
            </div>
        );
    }

    renderResults() {
        const { results, page, sort, loading, monthKeys } = this.state;
        if (loading) return <div style={{ padding: 16, color: '#888' }}>Cargando...</div>;
        if (results.length === 0) {
            return <div style={{ padding: 16, color: '#888' }}>No hay datos de ventas en los últimos {NUM_MONTHS_WINDOW} meses.</div>;
        }

        const PAGE_SIZE = 50;
        const sorted = sortRows(results, sort);
        const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
        const currentPage = Math.min(page, totalPages);
        const paginated = sorted.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

        const headers = [
            { label: 'Producto', key: 'Producto', align: 'left' },
            { label: 'Categoría', key: 'Categoría', align: 'left' },
            { label: 'Subcategoría', key: 'Subcategoría', align: 'left' },
            ...monthKeys.map((key) => ({ label: monthKeyLabel(key), key, align: 'right' })),
        ];

        return (
            <div style={{ border: '1px solid #ebebeb', borderRadius: 10, overflow: 'hidden' }}>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                        <thead>
                            <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #ebebeb' }}>
                                {headers.map((h) => (
                                    <SortableTh key={h.key} header={h} sort={sort} onSort={this.handleSort} style={{ textAlign: h.align }} />
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {paginated.map((item) => (
                                <tr
                                    key={item.Id}
                                    style={{ borderBottom: '1px solid #f4f4f4' }}
                                    onMouseEnter={(e) => (e.currentTarget.style.background = '#f8fbff')}
                                    onMouseLeave={(e) => (e.currentTarget.style.background = '')}
                                >
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', fontWeight: 500, textAlign: 'left' }}>{item.Producto}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666', textAlign: 'left' }}>{item.Categoría}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666', textAlign: 'left' }}>{item.Subcategoría}</td>
                                    {monthKeys.map((key) => (
                                        <td key={key} style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666', textAlign: 'right' }}>
                                            {fmtMoney(item[key])}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {this.renderPagination(sorted.length, currentPage, PAGE_SIZE, (p) => this.setState({ page: p }))}
            </div>
        );
    }

    render() {
        const { results, sort, monthKeys, selectedOption } = this.state;
        const sortedResults = sortRows(results, sort);
        const csvHeaders = [
            { label: 'Producto', key: 'Producto' },
            { label: 'Categoría', key: 'Categoría' },
            { label: 'Subcategoría', key: 'Subcategoría' },
            ...monthKeys.map((key) => ({ label: monthKeyLabel(key), key })),
        ];
        const rangeLabel = monthKeys.length > 0
            ? `${monthKeyLabel(monthKeys[0])} – ${monthKeyLabel(monthKeys[monthKeys.length - 1])}`
            : '';

        return (
            <Fragment>
                <Breadcrumb title="Desempeño de SKUs" parent="Analítica" />

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card" style={{ marginBottom: 16 }}>
                                <div className="card-body" style={{ padding: '12px 16px' }}>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>
                                        <span style={{ fontSize: 13, fontWeight: 600, color: '#555', whiteSpace: 'nowrap' }}>
                                            Mes
                                        </span>
                                        <div style={{ flex: '1 1 200px', minWidth: 160, maxWidth: 280 }}>
                                            <Select
                                                placeholder="Elegí un mes..."
                                                value={selectedOption}
                                                onChange={this.handleChange}
                                                options={this.state.dataCateg}
                                            />
                                        </div>
                                        <span style={{ fontSize: 12, color: '#999' }}>
                                            (ventana de {NUM_MONTHS_WINDOW} meses hacia atrás desde el mes elegido)
                                        </span>
                                        {rangeLabel && (
                                            <span style={{ fontSize: 12, color: '#999', whiteSpace: 'nowrap' }}>{rangeLabel}</span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="card" style={{ boxShadow: 'none', border: '1px solid #ebebeb' }}>
                                <div
                                    className="card-header"
                                    style={{
                                        display: 'flex', flexWrap: 'wrap', alignItems: 'center',
                                        justifyContent: 'space-between', gap: 10,
                                    }}
                                >
                                    <h5 style={{ margin: 0 }}>Ventas por SKU y mes</h5>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>
                                        <input
                                            placeholder="Buscar..."
                                            name="filter"
                                            type="text"
                                            className="form-control"
                                            autoComplete="off"
                                            onInput={this.onChangeFilter}
                                            style={{
                                                flex: '1 1 180px', minWidth: 140, maxWidth: 260,
                                                height: 32, boxSizing: 'border-box', padding: '4px 10px',
                                            }}
                                        />
                                        {results.length > 0 && (
                                            <CSVLink
                                                className="btn btn-outline-primary btn-sm"
                                                data={sortedResults}
                                                headers={csvHeaders}
                                                filename={csvFilename(monthKeys)}
                                                style={{
                                                    display: 'inline-flex', alignItems: 'center', height: 32,
                                                    flexShrink: 0, whiteSpace: 'nowrap', boxSizing: 'border-box',
                                                }}
                                            >
                                                <i className="fa fa-file-excel-o" style={{ marginRight: 6 }} />
                                                Exportar
                                            </CSVLink>
                                        )}
                                    </div>
                                </div>
                                <div className="card-body" style={{ padding: 0 }}>
                                    {this.renderResults()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default VerReportSkuForMonth;
